import Title from "../components/TheTitle.vue";
import CouponInfo from "../components/CouponInfo.vue";
import { searchCouponHistory, searchUser, deleteCoupon, searchCouponBulkOperationHistory, } from "../api";
import { FormatDate } from "../utils/formatDate";
import { Authorize } from "../utils/authorize";
export default {
    name: "CouponDetail",
    data() {
        return {
            tableInfo: [],
            pageSize: 100,
            infoPage: 1,
            couponCode: "",
            sCResult: [],
            sUResult: [],
            deleteId: null,
            show: false,
        };
    },
    components: {
        Title,
        CouponInfo,
    },
    computed: {
        infoTotalPages() {
            return Math.max(1, Math.ceil(this.tableInfo.length / this.pageSize));
        },
        pagedInfo() {
            const start = (this.infoPage - 1) * this.pageSize;
            return this.tableInfo.slice(start, start + this.pageSize);
        },
    },
    watch: {
        // データが変更されたらページを先頭に戻す
        info() {
            this.infoPage = 1;
        },
    },
    async created() {
        const route = this.$route;
        const codeFromParams = (route && route.params && route.params.couponCode) || "";
        // 優先順位は params > query
        this.couponCode = codeFromParams || "";
        if (!this.couponCode)
            return;
        await this.callApi(this.couponCode);
        if (!this.sCResult.length || !this.sUResult.length)
            return;
        await this.mergeInfo(this.sCResult, this.sUResult);
    },
    methods: {
        openModal() {
            this.show = true;
        },
        closeModal() {
            this.show = false;
        },
        redirectDeleteCoupon() {
            this.$router.push(`/couponDeleteResult/${this.deleteId}`).catch(() => {
                /* NavigationDuplicated 等のエラーを無視 */
            });
        },
        redirectGrantCoupon() {
            this.$router
                .push(`/bulkCouponAllocationTargetSearch/${this.couponCode}`)
                .catch(() => {
                /* NavigationDuplicated 等のエラーを無視 */
            });
        },
        async deleteCoupon() {
            const operator = this.$store.state.displayName;
            const rspBody = await deleteCoupon(this.couponCode, operator);
            if (rspBody.result?.code === 9) {
                if (rspBody.result?.messages) {
                    this.$store.commit("setMessages", rspBody.result.messages);
                    this.$store.commit("setCancelBtnHide", true);
                    this.$store.commit("setIsModalOpen", true);
                    this.closeModal();
                }
                return;
            }
            const couponBulkOperationHistoryId = rspBody.data
                ?.coupon_bulk_operation_history_id;
            this.$router
                .push(`/couponDeleteResult/${couponBulkOperationHistoryId}`)
                .catch(() => {
                /* NavigationDuplicated 等のエラーを無視 */
            });
        },
        setInfoPage(p) {
            if (p < 1)
                p = 1;
            if (p > this.infoTotalPages)
                p = this.infoTotalPages;
            this.infoPage = p;
        },
        async callApi(couponCode) {
            // クーポン一括操作履歴検索APIを呼び出す
            const sCBOHRspBody = await searchCouponBulkOperationHistory(null, couponCode, "1", null, null, null, null, null, null, null, null, null, null);
            if (sCBOHRspBody.result?.code === 9) {
                this.$store.commit("setMessages", sCBOHRspBody.result.messages);
                this.$store.commit("setCancelBtnHide", true);
                this.$store.commit("setIsModalOpen", true);
            }
            else {
                const sCBOHResult = sCBOHRspBody.data.results;
                this.deleteId = sCBOHResult.length
                    ? sCBOHResult[0].coupon_bulk_operation_history_id
                    : null;
            }
            // ポイント履歴検索APIを呼び出す
            const sCRspBody = await searchCouponHistory(undefined, 0, undefined, undefined, undefined, undefined, couponCode);
            if (sCRspBody.result?.code === 9) {
                if (sCRspBody.result?.messages) {
                    this.$store.commit("setMessages", sCRspBody.result.messages);
                    this.$store.commit("setCancelBtnHide", true);
                    this.$store.commit("setIsModalOpen", true);
                }
                return;
            }
            this.sCResult = sCRspBody.data?.results;
            if (!this.sCResult.length)
                return;
            // ユーザ検索APIを呼び出す
            const customerIds = this.sCResult.map((r) => r.crm_customer_id);
            const sURspBody = await searchUser(customerIds, null, null, null, null, null, null);
            if (sURspBody.result?.code === 9) {
                if (sURspBody.result?.messages) {
                    this.$store.commit("setMessages", sURspBody.result.messages);
                    this.$store.commit("setCancelBtnHide", true);
                    this.$store.commit("setIsModalOpen", true);
                }
                return;
            }
            this.sUResult = sURspBody.data?.results;
            return;
        },
        async mergeInfo(CouponHistoryInfoList, UserInfoList) {
            // ユーザを crm_customer_id -> UserInfo の Map に変換
            const userMap = new Map();
            for (const u of UserInfoList) {
                if (u && u.crm_customer_id)
                    userMap.set(u.crm_customer_id, u);
            }
            // 日付をフォーマットするヘルパー
            const formatDatetime = (value) => {
                return FormatDate.withoutTzAndMs(value);
            };
            const merged = CouponHistoryInfoList.map((c) => {
                const user = userMap.get(c.crm_customer_id);
                return {
                    crm_customer_id: c.crm_customer_id || "",
                    user_name: user?.name || "",
                    mobile_phone_number: user?.mobile_phone_number || "",
                    history_date: formatDatetime(c.history_date),
                    store: c.grant_store,
                    granted_by: c.granted_by,
                };
            });
            // 反映
            this.tableInfo = merged;
            return;
        },
    },
    async mounted() {
        await Authorize.isExpired(this);
    },
};
